import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: "/index.html",
    name: "index",
    redirect: '/',
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Archived',
    name: 'Archived',
    component: () => import('../views/Archived.vue'),
  },
  {
    path: '/compose/pot',
    name: 'ComposePot',
    component: Home
  },
  {
    path: '/tools',
    component: () => import('../views/Tools.vue'),
    children: [
      {
        path: '/',
        name: "ToolsTop",
      },
      {
        path: 'import',
        name: "ToolsImport",
        component: () => import('../components/Tools/Import.vue'),
      },
      {
        path: 'import/:id',
        name: "ToolsImportURL",
        component: () => import('../components/Tools/Import.vue'),
      }
    ]
  },
  {
    path: '/settings',
    component: () => import('../views/Settings.vue'),
    children: [
      {
        path: '/',
        name: "SettingsTop",
      },
      {
        path: 'update',
        name: "SettingsUpdate",
        component: () => import('../components/Settings/Update.vue'),
      },
      {
        path: 'data',
        name: "SettingsData",
        component: () => import('../components/Settings/Data.vue'),
      },
      {
        path: 'cloud',
        name: "SettingsCloud",
        component: () => import('../components/Settings/Cloud.vue'),
      },
      {
        path: 'privacy',
        name: "SettingsPrivacy",
        component: () => import('../components/Settings/Privacy.vue'),
      },
      {
        path: 'about',
        name: "SettingsAbout",
        component: () => import('../components/Settings/About.vue'),
      }
    ]
  },
  {
    path: '/pots/:id',
    name: 'PotDetail',
    component: Home
  },
  {
    path: '/create',
    name: 'Create',
    component: Home
  },
  {
    path: '/webshare',
    name: 'webshare',
    component: () => import('../views/Webshare.vue'),
  },
  {
    path: '/explore',
    name: 'Explore',
    component: Home
  },
  {
    path: '/explore/url/:url',
    name: 'ExploreUrl',
    component: Home
  },
  {
    path: '/explore/tags/:tag',
    name: 'ExploreTag',
    component: Home
  },
  {
    path: '/favorite',
    name: 'Favorite',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
